import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=7cfca170&"
import script from "./ReturnPolicy.vue?vue&type=script&lang=ts&"
export * from "./ReturnPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports